<template>
  <div class="flex flex-col">
    <div class="max-w-448 w-full mx-auto mt-24 px-16 sm:px-0">
      <Breadcrumb :href="backHref" header="Back" :anchorLink="true" />
      <div class="flex flex-col items-center mt-24">
        <h2 class="text-h3 sm:text-h2">Did you successfully hire someone using Sittercity?</h2>
      </div>
      <form @submit.prevent="submitForm">
        <fieldset>
          <legend class="sr-only">Did you successfully hire someone using Sittercity?</legend>
          <div class="flex flex-col gap-16 items-center mt-24">
            <Card :elevation="3" class="w-full flex items-center">
              <RadioButton
                id="hire-successful"
                v-model="hireSuccessful"
                class="pb-8"
                labelName="Yes, I hired through Sittercity"
                radioName="hireSuccessful"
                radioValue="true"
              />
            </Card>
            <Card :elevation="3" class="w-full flex items-center">
              <RadioButton
                id="hire-not-successful"
                v-model="hireSuccessful"
                class="pb-8"
                labelName="No, I did not find someone"
                radioName="hireSuccessful"
                radioValue="false"
              />
            </Card>
          </div>
          <div
            class="absolute bottom-0 left-0 px-16 w-full border-t-1 border-solid border-grey-divider-subdued bg-foreground sm:static sm:px-0 sm:border-none"
          >
            <Button value="Next" variant="primary" size="medium" type="submit" class="w-full my-16 sm:mt-32" />
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import Breadcrumb from '../../../components/breadcrumb/Breadcrumb.vue';
import RadioButton from '../../../components/radio_button/RadioButton.vue';
import Card from '../../../components/card/Card.vue';
import Button from '../../../components/button/Button.vue';

export default {
  name: 'Questionnaire',
  components: { Breadcrumb, RadioButton, Button, Card },
  data() {
    return {
      hireSuccessful: null,
    };
  },
  computed: {
    backHref() {
      if (document.referrer) {
        try {
          const url = new URL(document.referrer);
          return url.pathname + url.search;
        } catch (_error) {
          // Fall back to default if URL parsing fails
          return '/account/deactivation';
        }
      }
      return '/account/deactivation';
    },
  },
  methods: {
    submitForm() {
      return this.hireSuccessful === 'true'
        ? this.$router.push({ path: '/account/deactivation/sitter-select' })
        : this.$router.push({ path: '/account/deactivation/survey' });
    },
  },
};
</script>
